import MarkdownSpan from './component.jsx'
export default MarkdownSpan
